import { http } from '../../plugins/http'
import type { AxiosResponse } from 'axios'

import type PaginatedResponse from '@/types/PaginatedResponse'
import OrderItem from '@/types/OrderItem'

export default class SaleItemsService {
  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<OrderItem[]>>> {
    const _filters = new URLSearchParams()

    filters.split('&').forEach((pair) => {
      const [key, value] = pair.split('=')
      if (value) _filters.set(key, value)
    }) // prevents 'null' at the backend

    return await http.get<PaginatedResponse<OrderItem[]>>(`/api/v1/office/reports/sales/items?page=${page}&${_filters}&per_page=${per_page}`, {
      headers: { Accept: 'application/json' },
    })
  }

  async report(filters: string, selected: Record<string, string>): Promise<AxiosResponse<BlobPart>> {
    const _filters = new URLSearchParams()

    filters.split('&').forEach((pair) => {
      const [key, value] = pair.split('=')
      if (value) _filters.set(key, value)
    }) // prevents 'null' at the backend

    return await http.post(`/api/v1/office/reports/sales/items?${_filters.toString()}`,
      { selected },
      {
        headers: {
          Accept: 'application/csv',
        },
      },
    )
  }
}
